export const LikeQueryKey = {
    likedAudioIds: () => ['liked-audio-ids'],
}
